import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthGuard } from './core/guards/auth.guard';
// import { Page404Component } from './views/page-404/page-404.component'

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./routes/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    canActivate: [MsalGuard, AuthGuard],
  },
  // {
  //   path: 'code',
  //   component: UserLoginComponent
  // },

  {
    path: 'print/list/:locationId',
    loadChildren: () =>
      import(
        '../app/modules/reports/studentlist-report/student-list-print/student-list-print.module'
      ).then((m) => m.StudentListPrintModule),
    canActivate: [MsalGuard, AuthGuard],
  },

  {
    path: 'print/flipreport/:locationId',
    loadChildren: () =>
      import(
        '../app/modules/reports/fliplist-report/fliplist-print/fliplist-print.module'
      ).then((m) => m.FlipListPrintModule),
    canActivate: [MsalGuard, AuthGuard],
  },

  {
    path: 'print/staff/:locationId',
    loadChildren: () =>
      import(
        '../app/modules/reports/staff-list-report/staff-report-print/staff-report-print.module'
      ).then((m) => m.StaffReportPrintModule),
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: 'print/staff/staffschedule/:locationId',
    loadChildren: () =>
      import(
        './modules/reports/staff-schedule-print/staff-schedule-print.module'
      ).then((m) => m.StaffSchedulePrintModule),
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: 'print/child/alert/:locationId',
    loadChildren: () =>
      import(
        '../app/modules/reports/child-special-alert/child-special-alert-print/child-special-alert-print.module'
      ).then((m) => m.ChildSpecialAlertPrintModule),
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: 'print/child/allergymedical/:locationId',
    loadChildren: () =>
      import(
        './modules/reports/allergy_med_condition_report/allergy-print/allergy-print.module'
      ).then((m) => m.AllergyPrintModule),
    canActivate: [MsalGuard, AuthGuard],
  },
  {
    path: 'print/child/dietaryrestriction/:locationId',
    loadChildren: () =>
      import(
        '../app/modules/reports/dietary-restriction/dietary-print/dietary-print.module'
      ).then((m) => m.DietaryPrintModule),
    canActivate: [MsalGuard, AuthGuard],
  },

  {
    path: 'print/allergy/:id/:childId',
    loadChildren: () =>
      import(
        '../../src/app/modules/children/allergy-print/allergy-print.module'
      ).then((m) => m.AllergyPrintModule),
    canActivate: [MsalGuard, AuthGuard],
  },

  {
    path: 'emergency/:childId',
    loadChildren: () =>
      import(
        '../../src/app/modules/children/emergency-info-print/emergency-info-print.module'
      ).then((m) => m.EmergencyInfoPrintModule),
    canActivate: [MsalGuard, AuthGuard],
  },

  {
    path: 'attendance/:classId',
    loadChildren: () =>
      import(
        '../../src/app/modules/classroom/attendance-report/attendance-report.module'
      ).then((m) => m.AttendanceReportModule),
    canActivate: [MsalGuard, AuthGuard],
  },

  {
    path: 'print/warningletter',
    loadChildren: () =>
      import(
        '../../src/app/modules/children/children-details/attendance/attendance-letter-print/attendance-letter-print.module'
      ).then((m) => m.AttendanceLetterPrintModule),
    canActivate: [MsalGuard, AuthGuard],
  },

  {
    path: 'print/notice',
    loadChildren: () =>
      import(
        '../../src/app/shared/print-notice/print-notice.module'
      ).then((m) => m.PrintNoticeModule),
    canActivate: [MsalGuard, AuthGuard],
  },

  {
    path: 'unauthorised',
    loadChildren: () =>
      import('./routes/unauthorised/unauthorised.module').then(
        (m) => m.UnauthorisedModule
      ),
    canActivate: [MsalGuard],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];

// const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
      useHash: false,
      // Don't perform initial navigation in iframes
      // initialNavigation: !isIframe ? 'enabled' : 'disabled'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
